export default __webpack_public_path__ + "static/media/45t.97249ba4.jpg";